import {Component, OnDestroy, OnInit,EventEmitter,Output, AfterViewInit} from '@angular/core';
import { IDialogView } from '@shared/components/ok-cancel-dialog/ok-cancel-dialog.component';
import {select, Store} from '@ngrx/store';
import {takeUntil} from 'rxjs/operators';
import {TaxFormSupportiveLanguage} from '../../../models/tax-forms.model';
import {Subject} from 'rxjs';
import {TaxFormsService} from '../../../services/tax-forms.service';
import {SnackBarService} from '@core/services/snack-bar.service';
import { StringUtility } from '@shared/utility/string-utility';
import { FuseSplashScreenService } from '@barebone-fuse-services/splash-screen.service';
import { MatDialogRef } from '@angular/material/dialog';
import { DialogModel } from '@shared/models/dialog.model';
@Component({
    standalone: false,
    selector: 'particle-form-toolbar-translation-dialog',
  templateUrl: './form-toolbar-translation-dialog.component.html',
  styleUrls: ['./form-toolbar-translation-dialog.component.scss']
})
export class FormToolbarTranslationDialogComponent implements OnInit, IDialogView , OnDestroy,AfterViewInit {
  data: DialogModel;
  unsubscribe$ = new Subject<void>();
  fileToUpload: File;
  isFileScanned: boolean;
  isNotAForm: boolean;
  toLanguage: string;
  fromLanguage: string;
  currentTaxForm: any;
  taxformsSupportiveLanguage: TaxFormSupportiveLanguage[] = [];
  private language$: any;
  isCheckFileFormat: boolean = true;
  bringNewDataIntoTranslatedForm: boolean = false;
  pdfSelected: boolean = false;
  docOrExcelSelected: boolean = false;
  fileExtention: string = null;
  fileIdByUploading: string = null;

  constructor(private taxFormsService: TaxFormsService, private snackBarService: SnackBarService, private fuseSplashScreenService: FuseSplashScreenService,  public dialogRef: MatDialogRef<FormToolbarTranslationDialogComponent> ) {
    this.isFileScanned = false;
    this.fileExtention = null;
    this.fromLanguage = null;
    this.toLanguage = null;
    this.currentTaxForm = null;
    this.isNotAForm = false;
   }


  ngOnInit() {
    this.taxformsSupportiveLanguage = this.data.input.translationSupportiveLanguage;
    console.log('lang:, ', this.taxformsSupportiveLanguage);
    this.bringNewDataIntoTranslatedForm = false;
  }
  onOkClicked(): boolean {
    const action = 'Translate';
    this.fileExtention = StringUtility.getFileExtension(this.fileToUpload).toLowerCase();
    if (!this.fileToUpload) {
      this.snackBarService.showError('Please select a file.');
      return false;
    }
    if (!this.toLanguage) {
      this.snackBarService.showError('Please select a from language.');
      return;
    }

    if (!this.toLanguage) {
      this.snackBarService.showError('Please select a to language.');
      return;
    }

    if (this.isFileScanned && (this.taxFormsService.isOcrNotSupportiveLanguageSelected(this.fromLanguage) || this.taxFormsService.isOcrNotSupportiveLanguageSelected(this.toLanguage))) {
      this.snackBarService.showError('The language in the scanned document you are uploading is not supported by our OCR engine.\n' +
        'Please upload an electronic version of the document.');
      return false;
    }

    this.data.input.formConfig = {
      action: action,
      fileType: this.fileExtention,
      isFileScanned: this.isFileScanned,
      isNotAForm: this.isNotAForm,
      fromLanguage: this.fromLanguage,
      toLanguage: this.toLanguage,
      file: this.fileToUpload,
      toolName: 'Forms',
      isForm: true,
      pdfSelected: this.pdfSelected,
      docOrExcelSelected: this.docOrExcelSelected,
      fileId: this.fileIdByUploading,
      fileName: this.fileToUpload.name
    };
    if(this.fileToUpload){
      this.fileUploader();
      return false;
    }
    return false;
  }
  ngAfterViewInit(): void {}

  handleCheckbox() {
    if (this.isFileScanned) {
      this.isNotAForm = false;
    }
  }

  handleFileInput() {
    const expectedType: any[] = ['.pdf', '.doc', '.docx', '.xls', '.xlsx'];
    const fileFormatOutput = this.taxFormsService.handleFileInput(this.fileToUpload, expectedType);
    if (fileFormatOutput) {
      this.isCheckFileFormat = true;
      this.checkForPdfOrDoc();
    } else {
      this.snackBarService.showError('Please select a file of supported format.');
      this.isCheckFileFormat = false;
      this.fileToUpload = null;
      this.pdfSelected = false;
      this.docOrExcelSelected = false;
    }
  }

  private checkForPdfOrDoc() {
    this.fileExtention = StringUtility.getFileExtension(this.fileToUpload.name);
    if (this.fileExtention) {
      if (this.fileExtention === '.pdf') {
        this.docOrExcelSelected = false;
        this.pdfSelected = true;
      } else if (this.fileExtention === '.xlsx' || this.fileExtention === '.doc' || this.fileExtention === '.docx' || this.fileExtention === '.xls' ) {
        this.docOrExcelSelected = true;
        this.pdfSelected = false;
      } else {
        this.docOrExcelSelected = false;
        this.pdfSelected = false;
      }
    }
  }
  fileUploader(){
    const documentType = this.isFileScanned ? 'Scanned Document' : 'Electronic Document';
    this.fuseSplashScreenService.show();
     this.taxFormsService.uploadUserTaxForm(this.fileToUpload, documentType).pipe(takeUntil(this.unsubscribe$)).subscribe(data => {
      if (data && data.fileId) {
        this.fileIdByUploading = data.fileId;
        this.fuseSplashScreenService.hide();
        this.dialogRef.close({action:'ok',data: this.data, fileId: this.fileIdByUploading});
      }
      else{
        this.snackBarService.showError('File upload failed!!!');
      }
    }, err => {
      this.fuseSplashScreenService.hide();
      this.snackBarService.showError('File upload failed!!!');
    });
  }

  ngOnDestroy() {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

}





